module.exports = {
	"contractName": "Alias",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "verifier",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "names",
			"outputs": [
				{
					"name": "",
					"type": "bytes32"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				}
			],
			"name": "nameToAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "commissionPercent",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				}
			],
			"name": "nameToSaleOffer",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "basePrice",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "creationTime",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_newOwner",
					"type": "address"
				}
			],
			"name": "changeOwner",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_newVerifier",
					"type": "address"
				}
			],
			"name": "changeVerifier",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_account",
					"type": "address"
				}
			],
			"name": "withdraw",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_name",
					"type": "bytes32"
				}
			],
			"name": "get",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_name",
					"type": "bytes32"
				}
			],
			"name": "getPrice",
			"outputs": [
				{
					"name": "price",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getCount",
			"outputs": [
				{
					"name": "count",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_name",
					"type": "bytes32"
				}
			],
			"name": "buy",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_name",
					"type": "bytes32"
				},
				{
					"name": "_price",
					"type": "uint256"
				}
			],
			"name": "putForSale",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "93:3070:0:-;;;138:9;114:33;;185:2;153:34;;194:33;;;217:10;-1:-1:-1;;;;;;194:33:0;;;;;;;;233:36;;;;;;;;;;;303:3;276:30;;93:3070;5:2:-1;;;;30:1;27;20:12;5:2;93:3070:0;;;;;;;",
	"deployedSourceMap": "93:3070:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;233:36;;8:9:-1;5:2;;;30:1;27;20:12;5:2;233:36:0;;;;;;;;-1:-1:-1;;;;;233:36:0;;;;;;;;;;;;;;1814:432;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1814:432:0;;;;;;;;;;;;;;;;;;;;;443:22;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;443:22:0;;;;;313:49;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;313:49:0;;;;;1437:148;;-1:-1:-1;;;;;1437:148:0;;;;;;;2954:207;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2954:207:0;;;;;;;153:34;;8:9:-1;5:2;;;30:1;27;20:12;5:2;153:34:0;;;;194:33;;8:9:-1;5:2;;;30:1;27;20:12;5:2;194:33:0;;;;1616:192;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1616:192:0;;;;;389:48;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;389:48:0;;;;;2350:598;;;;;;1187:113;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1187:113:0;-1:-1:-1;;;;;1187:113:0;;;;;2252:92;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2252:92:0;;;;114:33;;8:9:-1;5:2;;;30:1;27;20:12;5:2;114:33:0;;;;1306:125;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1306:125:0;-1:-1:-1;;;;;1306:125:0;;;;;276:30;;8:9:-1;5:2;;;30:1;27;20:12;5:2;276:30:0;;;;233:36;;;-1:-1:-1;;;;;233:36:0;;:::o;1814:432::-;1907:10;1942:12;1957:14;1965:5;1957:7;:14::i;:::-;2016:1;1985:19;;;:13;:19;;;;;;1942:29;;-1:-1:-1;;;;;;1985:19:0;:33;1981:259;;;2041:9;;2034:16;;;;1981:259;2095:1;2071:21;;;:15;:21;;;;;;:25;2067:173;;;2167:17;;2143:21;;;;:15;:21;;;;;;2187:3;2143:41;;;:47;;;;2119:71;;-1:-1:-1;2112:78:0;;2067:173;2228:1;2221:8;;2067:173;1814:432;;;;:::o;443:22::-;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;443:22:0;:::o;313:49::-;;;;;;;;;;;;-1:-1:-1;;;;;313:49:0;;:::o;1437:148::-;1131:5;;-1:-1:-1;;;;;1131:5:0;1117:10;:19;1109:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1538:40;;-1:-1:-1;;;;;1538:17:0;;;1564:4;1556:21;1538:40;;;;;;;;;1556:21;1538:17;:40;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1538:40:0;1437:148;:::o;2954:207::-;3033:12;3048:14;3056:5;3048:7;:14::i;:::-;3080:19;;;;:13;:19;;;;;;3033:29;;-1:-1:-1;;;;;;3080:19:0;3103:10;3080:33;3072:42;;;;;;3124:21;;;;:15;:21;;;;;:30;-1:-1:-1;2954:207:0:o;153:34::-;;;;:::o;194:33::-;;;-1:-1:-1;;;;;194:33:0;;:::o;1616:192::-;1704:7;1736:12;1751:14;1759:5;1751:7;:14::i;:::-;1782:19;;;;:13;:19;;;;;;-1:-1:-1;;;;;1782:19:0;;1616:192;-1:-1:-1;;;1616:192:0:o;389:48::-;;;;;;;;;;;;;:::o;2350:598::-;2425:12;2464:10;2440:14;2448:5;2440:7;:14::i;:::-;2477:19;;;;;;;;;;;;;;2425:29;;-1:-1:-1;2477:4:0;;:13;;:19;;;;;;;;;;;;;;;;:4;:19;;;5:2:-1;;;;30:1;27;20:12;5:2;2477:19:0;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;2477:19:0;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;2477:19:0;;-1:-1:-1;2514:9:0;:18;-1:-1:-1;2514:18:0;2506:27;;;;;;2578:1;2547:19;;;:13;:19;;;;;;-1:-1:-1;;;;;2547:19:0;:33;2543:262;;2628:1;2604:21;;;:15;:21;;;;;;:25;2596:34;;;;;;2644:19;;;;:13;:19;;;;;;;;;2673:15;:21;;;;;;;2644:51;;-1:-1:-1;;;;;2644:19:0;;;;:51;;;;;;;:19;:51;2673:21;2644:19;:51;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;2733:1:0;2709:21;;;:15;:21;;;;;:25;2543:262;;;2765:5;27:10:-1;;39:1;23:18;;45:23;;-1:-1;2765:16:0;;;;;;;;;2543:262;2814:19;;;;:13;:19;;;;;:32;;-1:-1:-1;;2814:32:0;2836:10;2814:32;;;2860:9;:17;-1:-1:-1;2856:86:0;;;2893:38;;:10;;2913:9;:17;;;2893:38;;;;;;;;;2913:17;2893:10;:38;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;2893:38:0;2856:86;2350:598;;;:::o;1187:113::-;1131:5;;-1:-1:-1;;;;;1131:5:0;1117:10;:19;1109:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1276:5;:17;;-1:-1:-1;;1276:17:0;-1:-1:-1;;;;;1276:17:0;;;;;;;;;;1187:113::o;2252:92::-;2325:5;:12;2252:92;:::o;114:33::-;;;;:::o;1306:125::-;1131:5;;-1:-1:-1;;;;;1131:5:0;1117:10;:19;1109:54;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1401:8;:23;;-1:-1:-1;;1401:23:0;-1:-1:-1;;;;;1401:23:0;;;;;;;;;;1306:125::o;276:30::-;;;;:::o;499:546::-;577:7;;;;624:392;645:11;641:15;;624:392;;;745:13;:4;750:1;745:7;;;;;;;;;;:13;;;;;744:34;;;;-1:-1:-1;764:13:0;:4;769:1;764:7;;;;;;;;;;:13;;;;;744:34;740:211;;;869:4;874:1;869:7;;;;;;;;;;863:14;;;880:2;863:19;858:25;;851:32;;740:211;;;929:4;934:1;929:7;;;;;;;;;;922:14;;740:211;1003:1;999:5;;974:31;;982:11;;;974:31;964:41;;;;;658:3;;;;;624:392;;;-1:-1:-1;1032:6:0;;499:546;-1:-1:-1;;;499:546:0:o",
	"source": "pragma solidity^0.4.24;\n\n/// @title Alias - maps bytes32 names to ethereum network addresses\ncontract Alias {\n    uint public basePrice = 50 finney;\n    uint public commissionPercent = 10;\n\n    address public owner = msg.sender;\n    address public verifier = msg.sender;\n\n    uint public creationTime = now;\n\n    mapping (bytes32 => address) public nameToAddress; // Approved mappings\n    mapping (bytes32 => uint) public nameToSaleOffer;\n    bytes32[] public names;\n\n    /// Utility Functions\n\n    function toLower(bytes32 bStr)\n        internal\n        pure\n        returns (bytes32)\n    {\n        bytes32 bLower;\n        for (uint i = 0; i < bStr.length; i++) {\n            // Uppercase character...\n            bytes1 char;\n            if ((bStr[i] >= 65) && (bStr[i] <= 90)) {\n                // So we add 32 to make it lowercase\n                char = byte(uint8(bStr[i]) + 32);\n            } else {\n                char = bStr[i];\n            }\n            bLower |= bytes32(char & 0xFF) >> (i * 8);\n        }\n        return bLower;\n    }\n\n    /// Owner Actions\n\n    modifier onlyOwner()\n    {\n        require(msg.sender == owner, \"Sender not authorized.\");\n        _;\n    }\n\n    function changeOwner(address _newOwner)\n        external\n        onlyOwner\n    {\n        owner = _newOwner;\n    }\n\n    function changeVerifier(address _newVerifier)\n        external\n        onlyOwner\n    {\n        verifier = _newVerifier;\n    }\n\n    function withdraw(address _account)\n        external\n        onlyOwner\n        payable\n    {\n        _account.transfer(address(this).balance);\n    }\n\n    // Public functions\n\n    function get(bytes32 _name)\n        external\n        view\n        returns (\n            address\n        )\n    {\n        bytes32 name = toLower(_name);\n        return nameToAddress[name];\n    }\n\n    function getPrice(bytes32 _name)\n        external\n        view\n        returns (\n            uint price\n        )\n    {\n        bytes32 name = toLower(_name);\n        if (nameToAddress[name] == address(0)) {\n            return basePrice;\n        } else if (nameToSaleOffer[name] > 0) {\n            return nameToSaleOffer[name] + nameToSaleOffer[name] * commissionPercent / 100;\n        } else {\n            return 0;\n        }\n    }\n\n    function getCount() public constant returns(uint count) {\n        return names.length;\n    }\n\n    function buy(bytes32 _name)\n        external\n        payable\n    {\n        bytes32 name = toLower(_name);\n        uint price = this.getPrice(name);\n        require(msg.value >= price);\n        if (nameToAddress[name] != address(0)) {\n            require(nameToSaleOffer[name] > 0);\n            nameToAddress[name].transfer(nameToSaleOffer[name]);\n            nameToSaleOffer[name] = 0;\n        } else {\n            names.push(name); // New alias\n        }\n        nameToAddress[name] = msg.sender;\n        if (msg.value > price) {\n            msg.sender.transfer(msg.value - price);\n        }\n    }\n\n    function putForSale(bytes32 _name, uint _price)\n        external\n    {\n        bytes32 name = toLower(_name);\n        require(nameToAddress[name] == msg.sender);\n        nameToSaleOffer[name] = _price;\n    }\n}\n",
	"sourcePath": "/Users/ranhalprin/Development/ethereum/fballcoin-drizzle/contracts/Alias.sol",
	"ast": {
		"absolutePath": "/Users/ranhalprin/Development/ethereum/fballcoin-drizzle/contracts/Alias.sol",
		"exportedSymbols": {
			"Alias": [
				351
			]
		},
		"id": 352,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:23:0"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": "@title Alias - maps bytes32 names to ethereum network addresses",
				"fullyImplemented": true,
				"id": 351,
				"linearizedBaseContracts": [
					351
				],
				"name": "Alias",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 4,
						"name": "basePrice",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "114:33:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2,
							"name": "uint",
							"nodeType": "ElementaryTypeName",
							"src": "114:4:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3530",
							"id": 3,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "138:9:0",
							"subdenomination": "finney",
							"typeDescriptions": {
								"typeIdentifier": "t_rational_50000000000000000_by_1",
								"typeString": "int_const 50000000000000000"
							},
							"value": "50"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 7,
						"name": "commissionPercent",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "153:34:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 5,
							"name": "uint",
							"nodeType": "ElementaryTypeName",
							"src": "153:4:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3130",
							"id": 6,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "185:2:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_10_by_1",
								"typeString": "int_const 10"
							},
							"value": "10"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 11,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "194:33:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 8,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "194:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": {
							"argumentTypes": null,
							"expression": {
								"argumentTypes": null,
								"id": 9,
								"name": "msg",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 1465,
								"src": "217:3:0",
								"typeDescriptions": {
									"typeIdentifier": "t_magic_message",
									"typeString": "msg"
								}
							},
							"id": 10,
							"isConstant": false,
							"isLValue": false,
							"isPure": false,
							"lValueRequested": false,
							"memberName": "sender",
							"nodeType": "MemberAccess",
							"referencedDeclaration": null,
							"src": "217:10:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 15,
						"name": "verifier",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "233:36:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 12,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "233:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": {
							"argumentTypes": null,
							"expression": {
								"argumentTypes": null,
								"id": 13,
								"name": "msg",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 1465,
								"src": "259:3:0",
								"typeDescriptions": {
									"typeIdentifier": "t_magic_message",
									"typeString": "msg"
								}
							},
							"id": 14,
							"isConstant": false,
							"isLValue": false,
							"isPure": false,
							"lValueRequested": false,
							"memberName": "sender",
							"nodeType": "MemberAccess",
							"referencedDeclaration": null,
							"src": "259:10:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 18,
						"name": "creationTime",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "276:30:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 16,
							"name": "uint",
							"nodeType": "ElementaryTypeName",
							"src": "276:4:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"id": 17,
							"name": "now",
							"nodeType": "Identifier",
							"overloadedDeclarations": [],
							"referencedDeclaration": 1467,
							"src": "303:3:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 22,
						"name": "nameToAddress",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "313:49:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
							"typeString": "mapping(bytes32 => address)"
						},
						"typeName": {
							"id": 21,
							"keyType": {
								"id": 19,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "322:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"nodeType": "Mapping",
							"src": "313:28:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
								"typeString": "mapping(bytes32 => address)"
							},
							"valueType": {
								"id": 20,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "333:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 26,
						"name": "nameToSaleOffer",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "389:48:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
							"typeString": "mapping(bytes32 => uint256)"
						},
						"typeName": {
							"id": 25,
							"keyType": {
								"id": 23,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "398:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"nodeType": "Mapping",
							"src": "389:25:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
								"typeString": "mapping(bytes32 => uint256)"
							},
							"valueType": {
								"id": 24,
								"name": "uint",
								"nodeType": "ElementaryTypeName",
								"src": "409:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 29,
						"name": "names",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "443:22:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_bytes32_$dyn_storage",
							"typeString": "bytes32[]"
						},
						"typeName": {
							"baseType": {
								"id": 27,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "443:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"id": 28,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "443:9:0",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_bytes32_$dyn_storage_ptr",
								"typeString": "bytes32[]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 104,
							"nodeType": "Block",
							"src": "590:455:0",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 37,
											"name": "bLower",
											"nodeType": "VariableDeclaration",
											"scope": 105,
											"src": "600:14:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 36,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "600:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 38,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "600:14:0"
								},
								{
									"body": {
										"id": 100,
										"nodeType": "Block",
										"src": "663:353:0",
										"statements": [
											{
												"assignments": [],
												"declarations": [
													{
														"constant": false,
														"id": 51,
														"name": "char",
														"nodeType": "VariableDeclaration",
														"scope": 105,
														"src": "715:11:0",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes1",
															"typeString": "bytes1"
														},
														"typeName": {
															"id": 50,
															"name": "bytes1",
															"nodeType": "ElementaryTypeName",
															"src": "715:6:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes1",
																"typeString": "bytes1"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 52,
												"initialValue": null,
												"nodeType": "VariableDeclarationStatement",
												"src": "715:11:0"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 65,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																},
																"id": 57,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 53,
																		"name": "bStr",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 31,
																		"src": "745:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"id": 55,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 54,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "750:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "745:7:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">=",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "3635",
																	"id": 56,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "756:2:0",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_65_by_1",
																		"typeString": "int_const 65"
																	},
																	"value": "65"
																},
																"src": "745:13:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 58,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "744:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																},
																"id": 63,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 59,
																		"name": "bStr",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 31,
																		"src": "764:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"id": 61,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 60,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "769:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "764:7:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "<=",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "3930",
																	"id": 62,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "775:2:0",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_90_by_1",
																		"typeString": "int_const 90"
																	},
																	"value": "90"
																},
																"src": "764:13:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 64,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "763:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "744:34:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 85,
													"nodeType": "Block",
													"src": "904:47:0",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 83,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 79,
																	"name": "char",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 51,
																	"src": "922:4:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 80,
																		"name": "bStr",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 31,
																		"src": "929:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"id": 82,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 81,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "934:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "929:7:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"src": "922:14:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																}
															},
															"id": 84,
															"nodeType": "ExpressionStatement",
															"src": "922:14:0"
														}
													]
												},
												"id": 86,
												"nodeType": "IfStatement",
												"src": "740:211:0",
												"trueBody": {
													"id": 78,
													"nodeType": "Block",
													"src": "780:118:0",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 76,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 66,
																	"name": "char",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 51,
																	"src": "851:4:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint8",
																				"typeString": "uint8"
																			},
																			"id": 74,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"arguments": [
																					{
																						"argumentTypes": null,
																						"baseExpression": {
																							"argumentTypes": null,
																							"id": 69,
																							"name": "bStr",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 31,
																							"src": "869:4:0",
																							"typeDescriptions": {
																								"typeIdentifier": "t_bytes32",
																								"typeString": "bytes32"
																							}
																						},
																						"id": 71,
																						"indexExpression": {
																							"argumentTypes": null,
																							"id": 70,
																							"name": "i",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 40,
																							"src": "874:1:0",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"nodeType": "IndexAccess",
																						"src": "869:7:0",
																						"typeDescriptions": {
																							"typeIdentifier": "t_bytes1",
																							"typeString": "bytes1"
																						}
																					}
																				],
																				"expression": {
																					"argumentTypes": [
																						{
																							"typeIdentifier": "t_bytes1",
																							"typeString": "bytes1"
																						}
																					],
																					"id": 68,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"nodeType": "ElementaryTypeNameExpression",
																					"src": "863:5:0",
																					"typeDescriptions": {
																						"typeIdentifier": "t_type$_t_uint8_$",
																						"typeString": "type(uint8)"
																					},
																					"typeName": "uint8"
																				},
																				"id": 72,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"kind": "typeConversion",
																				"lValueRequested": false,
																				"names": [],
																				"nodeType": "FunctionCall",
																				"src": "863:14:0",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint8",
																					"typeString": "uint8"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "+",
																			"rightExpression": {
																				"argumentTypes": null,
																				"hexValue": "3332",
																				"id": 73,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "880:2:0",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_32_by_1",
																					"typeString": "int_const 32"
																				},
																				"value": "32"
																			},
																			"src": "863:19:0",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint8",
																				"typeString": "uint8"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint8",
																				"typeString": "uint8"
																			}
																		],
																		"id": 67,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "858:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_bytes1_$",
																			"typeString": "type(bytes1)"
																		},
																		"typeName": "byte"
																	},
																	"id": 75,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "858:25:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"src": "851:32:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																}
															},
															"id": 77,
															"nodeType": "ExpressionStatement",
															"src": "851:32:0"
														}
													]
												}
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 98,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 87,
														"name": "bLower",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 37,
														"src": "964:6:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "Assignment",
													"operator": "|=",
													"rightHandSide": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														},
														"id": 97,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	},
																	"id": 91,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 89,
																		"name": "char",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 51,
																		"src": "982:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes1",
																			"typeString": "bytes1"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "&",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "30784646",
																		"id": 90,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "989:4:0",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_255_by_1",
																			"typeString": "int_const 255"
																		},
																		"value": "0xFF"
																	},
																	"src": "982:11:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																],
																"id": 88,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "974:7:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_bytes32_$",
																	"typeString": "type(bytes32)"
																},
																"typeName": "bytes32"
															},
															"id": 92,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "974:20:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">>",
														"rightExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 95,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 93,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "999:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "*",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "38",
																		"id": 94,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "1003:1:0",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_8_by_1",
																			"typeString": "int_const 8"
																		},
																		"value": "8"
																	},
																	"src": "999:5:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"id": 96,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "998:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "974:31:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "964:41:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												},
												"id": 99,
												"nodeType": "ExpressionStatement",
												"src": "964:41:0"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 46,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 43,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 40,
											"src": "641:1:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 44,
												"name": "bStr",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 31,
												"src": "645:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"id": 45,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "645:11:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"src": "641:15:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 101,
									"initializationExpression": {
										"assignments": [
											40
										],
										"declarations": [
											{
												"constant": false,
												"id": 40,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 105,
												"src": "629:6:0",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 39,
													"name": "uint",
													"nodeType": "ElementaryTypeName",
													"src": "629:4:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 42,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 41,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "638:1:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "629:10:0"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 48,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "658:3:0",
											"subExpression": {
												"argumentTypes": null,
												"id": 47,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 40,
												"src": "658:1:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 49,
										"nodeType": "ExpressionStatement",
										"src": "658:3:0"
									},
									"nodeType": "ForStatement",
									"src": "624:392:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 102,
										"name": "bLower",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 37,
										"src": "1032:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"functionReturnParameters": 35,
									"id": 103,
									"nodeType": "Return",
									"src": "1025:13:0"
								}
							]
						},
						"documentation": "Utility Functions",
						"id": 105,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "toLower",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 32,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 31,
									"name": "bStr",
									"nodeType": "VariableDeclaration",
									"scope": 105,
									"src": "516:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 30,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "516:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "515:14:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 35,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 34,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 105,
									"src": "577:7:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 33,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "577:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "576:9:0"
						},
						"scope": 351,
						"src": "499:546:0",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 116,
							"nodeType": "Block",
							"src": "1099:82:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 111,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 108,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1465,
														"src": "1117:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 109,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1117:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 110,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 11,
													"src": "1131:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "1117:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
												"id": 112,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1138:24:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												},
												"value": "Sender not authorized."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												}
											],
											"id": 107,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1468,
												1469
											],
											"referencedDeclaration": 1469,
											"src": "1109:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 113,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1109:54:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 114,
									"nodeType": "ExpressionStatement",
									"src": "1109:54:0"
								},
								{
									"id": 115,
									"nodeType": "PlaceholderStatement",
									"src": "1173:1:0"
								}
							]
						},
						"documentation": "Owner Actions",
						"id": 117,
						"name": "onlyOwner",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 106,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1092:2:0"
						},
						"src": "1074:107:0",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 128,
							"nodeType": "Block",
							"src": "1266:34:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 126,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 124,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 11,
											"src": "1276:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 125,
											"name": "_newOwner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 119,
											"src": "1284:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1276:17:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 127,
									"nodeType": "ExpressionStatement",
									"src": "1276:17:0"
								}
							]
						},
						"documentation": null,
						"id": 129,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 122,
								"modifierName": {
									"argumentTypes": null,
									"id": 121,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 117,
									"src": "1252:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1252:9:0"
							}
						],
						"name": "changeOwner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 120,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 119,
									"name": "_newOwner",
									"nodeType": "VariableDeclaration",
									"scope": 129,
									"src": "1208:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 118,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1208:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1207:19:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 123,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1266:0:0"
						},
						"scope": 351,
						"src": "1187:113:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 140,
							"nodeType": "Block",
							"src": "1391:40:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 138,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 136,
											"name": "verifier",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 15,
											"src": "1401:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 137,
											"name": "_newVerifier",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 131,
											"src": "1412:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1401:23:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 139,
									"nodeType": "ExpressionStatement",
									"src": "1401:23:0"
								}
							]
						},
						"documentation": null,
						"id": 141,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 134,
								"modifierName": {
									"argumentTypes": null,
									"id": 133,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 117,
									"src": "1377:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1377:9:0"
							}
						],
						"name": "changeVerifier",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 132,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 131,
									"name": "_newVerifier",
									"nodeType": "VariableDeclaration",
									"scope": 141,
									"src": "1330:20:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 130,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1330:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1329:22:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 135,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1391:0:0"
						},
						"scope": 351,
						"src": "1306:125:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 157,
							"nodeType": "Block",
							"src": "1528:57:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 152,
															"name": "this",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1478,
															"src": "1564:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_Alias_$351",
																"typeString": "contract Alias"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_contract$_Alias_$351",
																"typeString": "contract Alias"
															}
														],
														"id": 151,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "1556:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 153,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1556:13:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 154,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1556:21:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 148,
												"name": "_account",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "1538:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 150,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1538:17:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 155,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1538:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 156,
									"nodeType": "ExpressionStatement",
									"src": "1538:40:0"
								}
							]
						},
						"documentation": null,
						"id": 158,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 146,
								"modifierName": {
									"argumentTypes": null,
									"id": 145,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 117,
									"src": "1498:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1498:9:0"
							}
						],
						"name": "withdraw",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 144,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 143,
									"name": "_account",
									"nodeType": "VariableDeclaration",
									"scope": 158,
									"src": "1455:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 142,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1455:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1454:18:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 147,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1528:0:0"
						},
						"scope": 351,
						"src": "1437:148:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 175,
							"nodeType": "Block",
							"src": "1726:82:0",
							"statements": [
								{
									"assignments": [
										166
									],
									"declarations": [
										{
											"constant": false,
											"id": 166,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 176,
											"src": "1736:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 165,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "1736:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 170,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 168,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 160,
												"src": "1759:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 167,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "1751:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 169,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1751:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1736:29:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 171,
											"name": "nameToAddress",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 22,
											"src": "1782:13:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
												"typeString": "mapping(bytes32 => address)"
											}
										},
										"id": 173,
										"indexExpression": {
											"argumentTypes": null,
											"id": 172,
											"name": "name",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 166,
											"src": "1796:4:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "1782:19:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"functionReturnParameters": 164,
									"id": 174,
									"nodeType": "Return",
									"src": "1775:26:0"
								}
							]
						},
						"documentation": null,
						"id": 176,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "get",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 161,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 160,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 176,
									"src": "1629:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 159,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "1629:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1628:15:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 164,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 163,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 176,
									"src": "1704:7:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 162,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1704:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1690:31:0"
						},
						"scope": 351,
						"src": "1616:192:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 222,
							"nodeType": "Block",
							"src": "1932:314:0",
							"statements": [
								{
									"assignments": [
										184
									],
									"declarations": [
										{
											"constant": false,
											"id": 184,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 223,
											"src": "1942:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 183,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "1942:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 188,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 186,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 178,
												"src": "1965:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 185,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "1957:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 187,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1957:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1942:29:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 195,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 189,
												"name": "nameToAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 22,
												"src": "1985:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
													"typeString": "mapping(bytes32 => address)"
												}
											},
											"id": 191,
											"indexExpression": {
												"argumentTypes": null,
												"id": 190,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 184,
												"src": "1999:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "1985:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "30",
													"id": 193,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2016:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													}
												],
												"id": 192,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "2008:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 194,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "2008:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1985:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 203,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 199,
													"name": "nameToSaleOffer",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 26,
													"src": "2071:15:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
														"typeString": "mapping(bytes32 => uint256)"
													}
												},
												"id": 201,
												"indexExpression": {
													"argumentTypes": null,
													"id": 200,
													"name": "name",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 184,
													"src": "2087:4:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "2071:21:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 202,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "2095:1:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "2071:25:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"id": 219,
											"nodeType": "Block",
											"src": "2207:33:0",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 217,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2228:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"functionReturnParameters": 182,
													"id": 218,
													"nodeType": "Return",
													"src": "2221:8:0"
												}
											]
										},
										"id": 220,
										"nodeType": "IfStatement",
										"src": "2067:173:0",
										"trueBody": {
											"id": 216,
											"nodeType": "Block",
											"src": "2098:103:0",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 214,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 204,
																"name": "nameToSaleOffer",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 26,
																"src": "2119:15:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																	"typeString": "mapping(bytes32 => uint256)"
																}
															},
															"id": 206,
															"indexExpression": {
																"argumentTypes": null,
																"id": 205,
																"name": "name",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 184,
																"src": "2135:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "2119:21:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "+",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 213,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 211,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 207,
																		"name": "nameToSaleOffer",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 26,
																		"src": "2143:15:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																			"typeString": "mapping(bytes32 => uint256)"
																		}
																	},
																	"id": 209,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 208,
																		"name": "name",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 184,
																		"src": "2159:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "2143:21:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "*",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 210,
																	"name": "commissionPercent",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 7,
																	"src": "2167:17:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "2143:41:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "/",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "313030",
																"id": 212,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2187:3:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_100_by_1",
																	"typeString": "int_const 100"
																},
																"value": "100"
															},
															"src": "2143:47:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "2119:71:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"functionReturnParameters": 182,
													"id": 215,
													"nodeType": "Return",
													"src": "2112:78:0"
												}
											]
										}
									},
									"id": 221,
									"nodeType": "IfStatement",
									"src": "1981:259:0",
									"trueBody": {
										"id": 198,
										"nodeType": "Block",
										"src": "2020:41:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 196,
													"name": "basePrice",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4,
													"src": "2041:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"functionReturnParameters": 182,
												"id": 197,
												"nodeType": "Return",
												"src": "2034:16:0"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 223,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getPrice",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 179,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 178,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 223,
									"src": "1832:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 177,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "1832:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1831:15:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 182,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 181,
									"name": "price",
									"nodeType": "VariableDeclaration",
									"scope": 223,
									"src": "1907:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 180,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "1907:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1893:34:0"
						},
						"scope": 351,
						"src": "1814:432:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 231,
							"nodeType": "Block",
							"src": "2308:36:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 228,
											"name": "names",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 29,
											"src": "2325:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$dyn_storage",
												"typeString": "bytes32[] storage ref"
											}
										},
										"id": 229,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "length",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "2325:12:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 227,
									"id": 230,
									"nodeType": "Return",
									"src": "2318:19:0"
								}
							]
						},
						"documentation": null,
						"id": 232,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getCount",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 224,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2269:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 227,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 226,
									"name": "count",
									"nodeType": "VariableDeclaration",
									"scope": 232,
									"src": "2296:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 225,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2296:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2295:12:0"
						},
						"scope": 351,
						"src": "2252:92:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 320,
							"nodeType": "Block",
							"src": "2415:533:0",
							"statements": [
								{
									"assignments": [
										238
									],
									"declarations": [
										{
											"constant": false,
											"id": 238,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 321,
											"src": "2425:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 237,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "2425:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 242,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 240,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 234,
												"src": "2448:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 239,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "2440:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 241,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2440:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2425:29:0"
								},
								{
									"assignments": [
										244
									],
									"declarations": [
										{
											"constant": false,
											"id": 244,
											"name": "price",
											"nodeType": "VariableDeclaration",
											"scope": 321,
											"src": "2464:10:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 243,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "2464:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 249,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 247,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 238,
												"src": "2491:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 245,
												"name": "this",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1478,
												"src": "2477:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Alias_$351",
													"typeString": "contract Alias"
												}
											},
											"id": 246,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "getPrice",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 223,
											"src": "2477:13:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$_t_bytes32_$returns$_t_uint256_$",
												"typeString": "function (bytes32) view external returns (uint256)"
											}
										},
										"id": 248,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2477:19:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2464:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 254,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 251,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1465,
														"src": "2514:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 252,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2514:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 253,
													"name": "price",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 244,
													"src": "2527:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "2514:18:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 250,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1468,
												1469
											],
											"referencedDeclaration": 1468,
											"src": "2506:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 255,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2506:27:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 256,
									"nodeType": "ExpressionStatement",
									"src": "2506:27:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 263,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 257,
												"name": "nameToAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 22,
												"src": "2547:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
													"typeString": "mapping(bytes32 => address)"
												}
											},
											"id": 259,
											"indexExpression": {
												"argumentTypes": null,
												"id": 258,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 238,
												"src": "2561:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "2547:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "30",
													"id": 261,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2578:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													}
												],
												"id": 260,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "2570:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 262,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "2570:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2547:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 294,
										"nodeType": "Block",
										"src": "2751:54:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 291,
															"name": "name",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 238,
															"src": "2776:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"expression": {
															"argumentTypes": null,
															"id": 288,
															"name": "names",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 29,
															"src": "2765:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_bytes32_$dyn_storage",
																"typeString": "bytes32[] storage ref"
															}
														},
														"id": 290,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "push",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2765:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_arraypush_nonpayable$_t_bytes32_$returns$_t_uint256_$",
															"typeString": "function (bytes32) returns (uint256)"
														}
													},
													"id": 292,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2765:16:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 293,
												"nodeType": "ExpressionStatement",
												"src": "2765:16:0"
											}
										]
									},
									"id": 295,
									"nodeType": "IfStatement",
									"src": "2543:262:0",
									"trueBody": {
										"id": 287,
										"nodeType": "Block",
										"src": "2582:163:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 269,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 265,
																	"name": "nameToSaleOffer",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 26,
																	"src": "2604:15:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																		"typeString": "mapping(bytes32 => uint256)"
																	}
																},
																"id": 267,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 266,
																	"name": "name",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 238,
																	"src": "2620:4:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "2604:21:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "30",
																"id": 268,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2628:1:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															},
															"src": "2604:25:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 264,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															1468,
															1469
														],
														"referencedDeclaration": 1468,
														"src": "2596:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
															"typeString": "function (bool) pure"
														}
													},
													"id": 270,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2596:34:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 271,
												"nodeType": "ExpressionStatement",
												"src": "2596:34:0"
											},
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 276,
																"name": "nameToSaleOffer",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 26,
																"src": "2673:15:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																	"typeString": "mapping(bytes32 => uint256)"
																}
															},
															"id": 278,
															"indexExpression": {
																"argumentTypes": null,
																"id": 277,
																"name": "name",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 238,
																"src": "2689:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "2673:21:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"expression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 272,
																"name": "nameToAddress",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 22,
																"src": "2644:13:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
																	"typeString": "mapping(bytes32 => address)"
																}
															},
															"id": 274,
															"indexExpression": {
																"argumentTypes": null,
																"id": 273,
																"name": "name",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 238,
																"src": "2658:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "2644:19:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"id": 275,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "transfer",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2644:28:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 279,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2644:51:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 280,
												"nodeType": "ExpressionStatement",
												"src": "2644:51:0"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 285,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 281,
															"name": "nameToSaleOffer",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 26,
															"src": "2709:15:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																"typeString": "mapping(bytes32 => uint256)"
															}
														},
														"id": 283,
														"indexExpression": {
															"argumentTypes": null,
															"id": 282,
															"name": "name",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 238,
															"src": "2725:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "2709:21:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 284,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2733:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "2709:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 286,
												"nodeType": "ExpressionStatement",
												"src": "2709:25:0"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 301,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 296,
												"name": "nameToAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 22,
												"src": "2814:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
													"typeString": "mapping(bytes32 => address)"
												}
											},
											"id": 298,
											"indexExpression": {
												"argumentTypes": null,
												"id": 297,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 238,
												"src": "2828:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "2814:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 299,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1465,
												"src": "2836:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2836:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2814:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 302,
									"nodeType": "ExpressionStatement",
									"src": "2814:32:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 306,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 303,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1465,
												"src": "2860:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 304,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "value",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2860:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"id": 305,
											"name": "price",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 244,
											"src": "2872:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "2860:17:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 319,
									"nodeType": "IfStatement",
									"src": "2856:86:0",
									"trueBody": {
										"id": 318,
										"nodeType": "Block",
										"src": "2879:63:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 315,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 312,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1465,
																	"src": "2913:3:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 313,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "value",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "2913:9:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "-",
															"rightExpression": {
																"argumentTypes": null,
																"id": 314,
																"name": "price",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 244,
																"src": "2925:5:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"src": "2913:17:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"expression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 307,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1465,
																"src": "2893:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 310,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "2893:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"id": 311,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "transfer",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2893:19:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 316,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2893:38:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 317,
												"nodeType": "ExpressionStatement",
												"src": "2893:38:0"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 321,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "buy",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 235,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 234,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 321,
									"src": "2363:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 233,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "2363:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2362:15:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 236,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2415:0:0"
						},
						"scope": 351,
						"src": "2350:598:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 349,
							"nodeType": "Block",
							"src": "3023:138:0",
							"statements": [
								{
									"assignments": [
										329
									],
									"declarations": [
										{
											"constant": false,
											"id": 329,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 350,
											"src": "3033:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 328,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "3033:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 333,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 331,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 323,
												"src": "3056:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 330,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "3048:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 332,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3048:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "3033:29:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 340,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 335,
														"name": "nameToAddress",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 22,
														"src": "3080:13:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
															"typeString": "mapping(bytes32 => address)"
														}
													},
													"id": 337,
													"indexExpression": {
														"argumentTypes": null,
														"id": 336,
														"name": "name",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 329,
														"src": "3094:4:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "3080:19:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 338,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1465,
														"src": "3103:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 339,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "3103:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3080:33:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 334,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1468,
												1469
											],
											"referencedDeclaration": 1468,
											"src": "3072:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 341,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3072:42:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 342,
									"nodeType": "ExpressionStatement",
									"src": "3072:42:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 347,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 343,
												"name": "nameToSaleOffer",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 26,
												"src": "3124:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
													"typeString": "mapping(bytes32 => uint256)"
												}
											},
											"id": 345,
											"indexExpression": {
												"argumentTypes": null,
												"id": 344,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 329,
												"src": "3140:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "3124:21:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 346,
											"name": "_price",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 325,
											"src": "3148:6:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "3124:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 348,
									"nodeType": "ExpressionStatement",
									"src": "3124:30:0"
								}
							]
						},
						"documentation": null,
						"id": 350,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "putForSale",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 326,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 323,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 350,
									"src": "2974:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 322,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "2974:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 325,
									"name": "_price",
									"nodeType": "VariableDeclaration",
									"scope": 350,
									"src": "2989:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 324,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2989:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2973:28:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 327,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "3023:0:0"
						},
						"scope": 351,
						"src": "2954:207:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					}
				],
				"scope": 352,
				"src": "93:3070:0"
			}
		],
		"src": "0:3164:0"
	},
	"legacyAST": {
		"absolutePath": "/Users/ranhalprin/Development/ethereum/fballcoin-drizzle/contracts/Alias.sol",
		"exportedSymbols": {
			"Alias": [
				351
			]
		},
		"id": 352,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:23:0"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": "@title Alias - maps bytes32 names to ethereum network addresses",
				"fullyImplemented": true,
				"id": 351,
				"linearizedBaseContracts": [
					351
				],
				"name": "Alias",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 4,
						"name": "basePrice",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "114:33:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2,
							"name": "uint",
							"nodeType": "ElementaryTypeName",
							"src": "114:4:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3530",
							"id": 3,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "138:9:0",
							"subdenomination": "finney",
							"typeDescriptions": {
								"typeIdentifier": "t_rational_50000000000000000_by_1",
								"typeString": "int_const 50000000000000000"
							},
							"value": "50"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 7,
						"name": "commissionPercent",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "153:34:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 5,
							"name": "uint",
							"nodeType": "ElementaryTypeName",
							"src": "153:4:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "3130",
							"id": 6,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "185:2:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_10_by_1",
								"typeString": "int_const 10"
							},
							"value": "10"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 11,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "194:33:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 8,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "194:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": {
							"argumentTypes": null,
							"expression": {
								"argumentTypes": null,
								"id": 9,
								"name": "msg",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 1465,
								"src": "217:3:0",
								"typeDescriptions": {
									"typeIdentifier": "t_magic_message",
									"typeString": "msg"
								}
							},
							"id": 10,
							"isConstant": false,
							"isLValue": false,
							"isPure": false,
							"lValueRequested": false,
							"memberName": "sender",
							"nodeType": "MemberAccess",
							"referencedDeclaration": null,
							"src": "217:10:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 15,
						"name": "verifier",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "233:36:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 12,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "233:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": {
							"argumentTypes": null,
							"expression": {
								"argumentTypes": null,
								"id": 13,
								"name": "msg",
								"nodeType": "Identifier",
								"overloadedDeclarations": [],
								"referencedDeclaration": 1465,
								"src": "259:3:0",
								"typeDescriptions": {
									"typeIdentifier": "t_magic_message",
									"typeString": "msg"
								}
							},
							"id": 14,
							"isConstant": false,
							"isLValue": false,
							"isPure": false,
							"lValueRequested": false,
							"memberName": "sender",
							"nodeType": "MemberAccess",
							"referencedDeclaration": null,
							"src": "259:10:0",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 18,
						"name": "creationTime",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "276:30:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 16,
							"name": "uint",
							"nodeType": "ElementaryTypeName",
							"src": "276:4:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"id": 17,
							"name": "now",
							"nodeType": "Identifier",
							"overloadedDeclarations": [],
							"referencedDeclaration": 1467,
							"src": "303:3:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 22,
						"name": "nameToAddress",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "313:49:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
							"typeString": "mapping(bytes32 => address)"
						},
						"typeName": {
							"id": 21,
							"keyType": {
								"id": 19,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "322:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"nodeType": "Mapping",
							"src": "313:28:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
								"typeString": "mapping(bytes32 => address)"
							},
							"valueType": {
								"id": 20,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "333:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 26,
						"name": "nameToSaleOffer",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "389:48:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
							"typeString": "mapping(bytes32 => uint256)"
						},
						"typeName": {
							"id": 25,
							"keyType": {
								"id": 23,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "398:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"nodeType": "Mapping",
							"src": "389:25:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
								"typeString": "mapping(bytes32 => uint256)"
							},
							"valueType": {
								"id": 24,
								"name": "uint",
								"nodeType": "ElementaryTypeName",
								"src": "409:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 29,
						"name": "names",
						"nodeType": "VariableDeclaration",
						"scope": 351,
						"src": "443:22:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_bytes32_$dyn_storage",
							"typeString": "bytes32[]"
						},
						"typeName": {
							"baseType": {
								"id": 27,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "443:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"id": 28,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "443:9:0",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_bytes32_$dyn_storage_ptr",
								"typeString": "bytes32[]"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 104,
							"nodeType": "Block",
							"src": "590:455:0",
							"statements": [
								{
									"assignments": [],
									"declarations": [
										{
											"constant": false,
											"id": 37,
											"name": "bLower",
											"nodeType": "VariableDeclaration",
											"scope": 105,
											"src": "600:14:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 36,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "600:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 38,
									"initialValue": null,
									"nodeType": "VariableDeclarationStatement",
									"src": "600:14:0"
								},
								{
									"body": {
										"id": 100,
										"nodeType": "Block",
										"src": "663:353:0",
										"statements": [
											{
												"assignments": [],
												"declarations": [
													{
														"constant": false,
														"id": 51,
														"name": "char",
														"nodeType": "VariableDeclaration",
														"scope": 105,
														"src": "715:11:0",
														"stateVariable": false,
														"storageLocation": "default",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes1",
															"typeString": "bytes1"
														},
														"typeName": {
															"id": 50,
															"name": "bytes1",
															"nodeType": "ElementaryTypeName",
															"src": "715:6:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes1",
																"typeString": "bytes1"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 52,
												"initialValue": null,
												"nodeType": "VariableDeclarationStatement",
												"src": "715:11:0"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 65,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																},
																"id": 57,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 53,
																		"name": "bStr",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 31,
																		"src": "745:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"id": 55,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 54,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "750:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "745:7:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">=",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "3635",
																	"id": 56,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "756:2:0",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_65_by_1",
																		"typeString": "int_const 65"
																	},
																	"value": "65"
																},
																"src": "745:13:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 58,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "744:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																},
																"id": 63,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 59,
																		"name": "bStr",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 31,
																		"src": "764:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"id": 61,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 60,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "769:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "764:7:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "<=",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "3930",
																	"id": 62,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "775:2:0",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_90_by_1",
																		"typeString": "int_const 90"
																	},
																	"value": "90"
																},
																"src": "764:13:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"id": 64,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "763:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "744:34:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": {
													"id": 85,
													"nodeType": "Block",
													"src": "904:47:0",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 83,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 79,
																	"name": "char",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 51,
																	"src": "922:4:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 80,
																		"name": "bStr",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 31,
																		"src": "929:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"id": 82,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 81,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "934:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "929:7:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"src": "922:14:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																}
															},
															"id": 84,
															"nodeType": "ExpressionStatement",
															"src": "922:14:0"
														}
													]
												},
												"id": 86,
												"nodeType": "IfStatement",
												"src": "740:211:0",
												"trueBody": {
													"id": 78,
													"nodeType": "Block",
													"src": "780:118:0",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 76,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"id": 66,
																	"name": "char",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 51,
																	"src": "851:4:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint8",
																				"typeString": "uint8"
																			},
																			"id": 74,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"arguments": [
																					{
																						"argumentTypes": null,
																						"baseExpression": {
																							"argumentTypes": null,
																							"id": 69,
																							"name": "bStr",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 31,
																							"src": "869:4:0",
																							"typeDescriptions": {
																								"typeIdentifier": "t_bytes32",
																								"typeString": "bytes32"
																							}
																						},
																						"id": 71,
																						"indexExpression": {
																							"argumentTypes": null,
																							"id": 70,
																							"name": "i",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 40,
																							"src": "874:1:0",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"nodeType": "IndexAccess",
																						"src": "869:7:0",
																						"typeDescriptions": {
																							"typeIdentifier": "t_bytes1",
																							"typeString": "bytes1"
																						}
																					}
																				],
																				"expression": {
																					"argumentTypes": [
																						{
																							"typeIdentifier": "t_bytes1",
																							"typeString": "bytes1"
																						}
																					],
																					"id": 68,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"nodeType": "ElementaryTypeNameExpression",
																					"src": "863:5:0",
																					"typeDescriptions": {
																						"typeIdentifier": "t_type$_t_uint8_$",
																						"typeString": "type(uint8)"
																					},
																					"typeName": "uint8"
																				},
																				"id": 72,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"kind": "typeConversion",
																				"lValueRequested": false,
																				"names": [],
																				"nodeType": "FunctionCall",
																				"src": "863:14:0",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint8",
																					"typeString": "uint8"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "+",
																			"rightExpression": {
																				"argumentTypes": null,
																				"hexValue": "3332",
																				"id": 73,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "880:2:0",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_32_by_1",
																					"typeString": "int_const 32"
																				},
																				"value": "32"
																			},
																			"src": "863:19:0",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint8",
																				"typeString": "uint8"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint8",
																				"typeString": "uint8"
																			}
																		],
																		"id": 67,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "858:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_bytes1_$",
																			"typeString": "type(bytes1)"
																		},
																		"typeName": "byte"
																	},
																	"id": 75,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "858:25:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																},
																"src": "851:32:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes1",
																	"typeString": "bytes1"
																}
															},
															"id": 77,
															"nodeType": "ExpressionStatement",
															"src": "851:32:0"
														}
													]
												}
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 98,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 87,
														"name": "bLower",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 37,
														"src": "964:6:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"nodeType": "Assignment",
													"operator": "|=",
													"rightHandSide": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														},
														"id": 97,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	},
																	"id": 91,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 89,
																		"name": "char",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 51,
																		"src": "982:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes1",
																			"typeString": "bytes1"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "&",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "30784646",
																		"id": 90,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "989:4:0",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_255_by_1",
																			"typeString": "int_const 255"
																		},
																		"value": "0xFF"
																	},
																	"src": "982:11:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_bytes1",
																		"typeString": "bytes1"
																	}
																],
																"id": 88,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "974:7:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_bytes32_$",
																	"typeString": "type(bytes32)"
																},
																"typeName": "bytes32"
															},
															"id": 92,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "974:20:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">>",
														"rightExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 95,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 93,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 40,
																		"src": "999:1:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "*",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "38",
																		"id": 94,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "1003:1:0",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_8_by_1",
																			"typeString": "int_const 8"
																		},
																		"value": "8"
																	},
																	"src": "999:5:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"id": 96,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "998:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "974:31:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"src": "964:41:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												},
												"id": 99,
												"nodeType": "ExpressionStatement",
												"src": "964:41:0"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 46,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 43,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 40,
											"src": "641:1:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "<",
										"rightExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 44,
												"name": "bStr",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 31,
												"src": "645:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"id": 45,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "645:11:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											}
										},
										"src": "641:15:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 101,
									"initializationExpression": {
										"assignments": [
											40
										],
										"declarations": [
											{
												"constant": false,
												"id": 40,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 105,
												"src": "629:6:0",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 39,
													"name": "uint",
													"nodeType": "ElementaryTypeName",
													"src": "629:4:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 42,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 41,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "638:1:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "629:10:0"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 48,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "658:3:0",
											"subExpression": {
												"argumentTypes": null,
												"id": 47,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 40,
												"src": "658:1:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 49,
										"nodeType": "ExpressionStatement",
										"src": "658:3:0"
									},
									"nodeType": "ForStatement",
									"src": "624:392:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 102,
										"name": "bLower",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 37,
										"src": "1032:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"functionReturnParameters": 35,
									"id": 103,
									"nodeType": "Return",
									"src": "1025:13:0"
								}
							]
						},
						"documentation": "Utility Functions",
						"id": 105,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "toLower",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 32,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 31,
									"name": "bStr",
									"nodeType": "VariableDeclaration",
									"scope": 105,
									"src": "516:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 30,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "516:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "515:14:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 35,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 34,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 105,
									"src": "577:7:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 33,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "577:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "576:9:0"
						},
						"scope": 351,
						"src": "499:546:0",
						"stateMutability": "pure",
						"superFunction": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 116,
							"nodeType": "Block",
							"src": "1099:82:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 111,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 108,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1465,
														"src": "1117:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 109,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "1117:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 110,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 11,
													"src": "1131:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "1117:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
												"id": 112,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "1138:24:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												},
												"value": "Sender not authorized."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
													"typeString": "literal_string \"Sender not authorized.\""
												}
											],
											"id": 107,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1468,
												1469
											],
											"referencedDeclaration": 1469,
											"src": "1109:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 113,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1109:54:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 114,
									"nodeType": "ExpressionStatement",
									"src": "1109:54:0"
								},
								{
									"id": 115,
									"nodeType": "PlaceholderStatement",
									"src": "1173:1:0"
								}
							]
						},
						"documentation": "Owner Actions",
						"id": 117,
						"name": "onlyOwner",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 106,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1092:2:0"
						},
						"src": "1074:107:0",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 128,
							"nodeType": "Block",
							"src": "1266:34:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 126,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 124,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 11,
											"src": "1276:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 125,
											"name": "_newOwner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 119,
											"src": "1284:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1276:17:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 127,
									"nodeType": "ExpressionStatement",
									"src": "1276:17:0"
								}
							]
						},
						"documentation": null,
						"id": 129,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 122,
								"modifierName": {
									"argumentTypes": null,
									"id": 121,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 117,
									"src": "1252:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1252:9:0"
							}
						],
						"name": "changeOwner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 120,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 119,
									"name": "_newOwner",
									"nodeType": "VariableDeclaration",
									"scope": 129,
									"src": "1208:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 118,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1208:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1207:19:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 123,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1266:0:0"
						},
						"scope": 351,
						"src": "1187:113:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 140,
							"nodeType": "Block",
							"src": "1391:40:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 138,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 136,
											"name": "verifier",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 15,
											"src": "1401:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 137,
											"name": "_newVerifier",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 131,
											"src": "1412:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1401:23:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 139,
									"nodeType": "ExpressionStatement",
									"src": "1401:23:0"
								}
							]
						},
						"documentation": null,
						"id": 141,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 134,
								"modifierName": {
									"argumentTypes": null,
									"id": 133,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 117,
									"src": "1377:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1377:9:0"
							}
						],
						"name": "changeVerifier",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 132,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 131,
									"name": "_newVerifier",
									"nodeType": "VariableDeclaration",
									"scope": 141,
									"src": "1330:20:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 130,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1330:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1329:22:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 135,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1391:0:0"
						},
						"scope": 351,
						"src": "1306:125:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 157,
							"nodeType": "Block",
							"src": "1528:57:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 152,
															"name": "this",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1478,
															"src": "1564:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_Alias_$351",
																"typeString": "contract Alias"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_contract$_Alias_$351",
																"typeString": "contract Alias"
															}
														],
														"id": 151,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "1556:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 153,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1556:13:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 154,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "1556:21:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 148,
												"name": "_account",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 143,
												"src": "1538:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 150,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1538:17:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 155,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1538:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 156,
									"nodeType": "ExpressionStatement",
									"src": "1538:40:0"
								}
							]
						},
						"documentation": null,
						"id": 158,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 146,
								"modifierName": {
									"argumentTypes": null,
									"id": 145,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 117,
									"src": "1498:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1498:9:0"
							}
						],
						"name": "withdraw",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 144,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 143,
									"name": "_account",
									"nodeType": "VariableDeclaration",
									"scope": 158,
									"src": "1455:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 142,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1455:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1454:18:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 147,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1528:0:0"
						},
						"scope": 351,
						"src": "1437:148:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 175,
							"nodeType": "Block",
							"src": "1726:82:0",
							"statements": [
								{
									"assignments": [
										166
									],
									"declarations": [
										{
											"constant": false,
											"id": 166,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 176,
											"src": "1736:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 165,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "1736:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 170,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 168,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 160,
												"src": "1759:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 167,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "1751:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 169,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1751:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1736:29:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 171,
											"name": "nameToAddress",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 22,
											"src": "1782:13:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
												"typeString": "mapping(bytes32 => address)"
											}
										},
										"id": 173,
										"indexExpression": {
											"argumentTypes": null,
											"id": 172,
											"name": "name",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 166,
											"src": "1796:4:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "1782:19:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"functionReturnParameters": 164,
									"id": 174,
									"nodeType": "Return",
									"src": "1775:26:0"
								}
							]
						},
						"documentation": null,
						"id": 176,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "get",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 161,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 160,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 176,
									"src": "1629:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 159,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "1629:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1628:15:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 164,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 163,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 176,
									"src": "1704:7:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 162,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1704:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1690:31:0"
						},
						"scope": 351,
						"src": "1616:192:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 222,
							"nodeType": "Block",
							"src": "1932:314:0",
							"statements": [
								{
									"assignments": [
										184
									],
									"declarations": [
										{
											"constant": false,
											"id": 184,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 223,
											"src": "1942:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 183,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "1942:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 188,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 186,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 178,
												"src": "1965:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 185,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "1957:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 187,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1957:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1942:29:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 195,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 189,
												"name": "nameToAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 22,
												"src": "1985:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
													"typeString": "mapping(bytes32 => address)"
												}
											},
											"id": 191,
											"indexExpression": {
												"argumentTypes": null,
												"id": 190,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 184,
												"src": "1999:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "1985:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "30",
													"id": 193,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2016:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													}
												],
												"id": 192,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "2008:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 194,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "2008:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1985:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 203,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 199,
													"name": "nameToSaleOffer",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 26,
													"src": "2071:15:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
														"typeString": "mapping(bytes32 => uint256)"
													}
												},
												"id": 201,
												"indexExpression": {
													"argumentTypes": null,
													"id": 200,
													"name": "name",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 184,
													"src": "2087:4:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "2071:21:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 202,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "2095:1:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "2071:25:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"id": 219,
											"nodeType": "Block",
											"src": "2207:33:0",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 217,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2228:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"functionReturnParameters": 182,
													"id": 218,
													"nodeType": "Return",
													"src": "2221:8:0"
												}
											]
										},
										"id": 220,
										"nodeType": "IfStatement",
										"src": "2067:173:0",
										"trueBody": {
											"id": 216,
											"nodeType": "Block",
											"src": "2098:103:0",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 214,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 204,
																"name": "nameToSaleOffer",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 26,
																"src": "2119:15:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																	"typeString": "mapping(bytes32 => uint256)"
																}
															},
															"id": 206,
															"indexExpression": {
																"argumentTypes": null,
																"id": 205,
																"name": "name",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 184,
																"src": "2135:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "2119:21:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "+",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 213,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 211,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 207,
																		"name": "nameToSaleOffer",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 26,
																		"src": "2143:15:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																			"typeString": "mapping(bytes32 => uint256)"
																		}
																	},
																	"id": 209,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 208,
																		"name": "name",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 184,
																		"src": "2159:4:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bytes32",
																			"typeString": "bytes32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "2143:21:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "*",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 210,
																	"name": "commissionPercent",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 7,
																	"src": "2167:17:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"src": "2143:41:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "/",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "313030",
																"id": 212,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2187:3:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_100_by_1",
																	"typeString": "int_const 100"
																},
																"value": "100"
															},
															"src": "2143:47:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "2119:71:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"functionReturnParameters": 182,
													"id": 215,
													"nodeType": "Return",
													"src": "2112:78:0"
												}
											]
										}
									},
									"id": 221,
									"nodeType": "IfStatement",
									"src": "1981:259:0",
									"trueBody": {
										"id": 198,
										"nodeType": "Block",
										"src": "2020:41:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 196,
													"name": "basePrice",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4,
													"src": "2041:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"functionReturnParameters": 182,
												"id": 197,
												"nodeType": "Return",
												"src": "2034:16:0"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 223,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getPrice",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 179,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 178,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 223,
									"src": "1832:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 177,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "1832:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1831:15:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 182,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 181,
									"name": "price",
									"nodeType": "VariableDeclaration",
									"scope": 223,
									"src": "1907:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 180,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "1907:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1893:34:0"
						},
						"scope": 351,
						"src": "1814:432:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 231,
							"nodeType": "Block",
							"src": "2308:36:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 228,
											"name": "names",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 29,
											"src": "2325:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$dyn_storage",
												"typeString": "bytes32[] storage ref"
											}
										},
										"id": 229,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "length",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "2325:12:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 227,
									"id": 230,
									"nodeType": "Return",
									"src": "2318:19:0"
								}
							]
						},
						"documentation": null,
						"id": 232,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getCount",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 224,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2269:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 227,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 226,
									"name": "count",
									"nodeType": "VariableDeclaration",
									"scope": 232,
									"src": "2296:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 225,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2296:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2295:12:0"
						},
						"scope": 351,
						"src": "2252:92:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 320,
							"nodeType": "Block",
							"src": "2415:533:0",
							"statements": [
								{
									"assignments": [
										238
									],
									"declarations": [
										{
											"constant": false,
											"id": 238,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 321,
											"src": "2425:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 237,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "2425:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 242,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 240,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 234,
												"src": "2448:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 239,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "2440:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 241,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2440:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2425:29:0"
								},
								{
									"assignments": [
										244
									],
									"declarations": [
										{
											"constant": false,
											"id": 244,
											"name": "price",
											"nodeType": "VariableDeclaration",
											"scope": 321,
											"src": "2464:10:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 243,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "2464:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 249,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 247,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 238,
												"src": "2491:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 245,
												"name": "this",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1478,
												"src": "2477:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Alias_$351",
													"typeString": "contract Alias"
												}
											},
											"id": 246,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "getPrice",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 223,
											"src": "2477:13:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$_t_bytes32_$returns$_t_uint256_$",
												"typeString": "function (bytes32) view external returns (uint256)"
											}
										},
										"id": 248,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2477:19:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2464:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 254,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 251,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1465,
														"src": "2514:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 252,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2514:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 253,
													"name": "price",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 244,
													"src": "2527:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "2514:18:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 250,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1468,
												1469
											],
											"referencedDeclaration": 1468,
											"src": "2506:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 255,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2506:27:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 256,
									"nodeType": "ExpressionStatement",
									"src": "2506:27:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 263,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 257,
												"name": "nameToAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 22,
												"src": "2547:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
													"typeString": "mapping(bytes32 => address)"
												}
											},
											"id": 259,
											"indexExpression": {
												"argumentTypes": null,
												"id": 258,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 238,
												"src": "2561:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "2547:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "30",
													"id": 261,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2578:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													}
												],
												"id": 260,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "2570:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 262,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "2570:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2547:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 294,
										"nodeType": "Block",
										"src": "2751:54:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 291,
															"name": "name",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 238,
															"src": "2776:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"expression": {
															"argumentTypes": null,
															"id": 288,
															"name": "names",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 29,
															"src": "2765:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_bytes32_$dyn_storage",
																"typeString": "bytes32[] storage ref"
															}
														},
														"id": 290,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "push",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2765:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_arraypush_nonpayable$_t_bytes32_$returns$_t_uint256_$",
															"typeString": "function (bytes32) returns (uint256)"
														}
													},
													"id": 292,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2765:16:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 293,
												"nodeType": "ExpressionStatement",
												"src": "2765:16:0"
											}
										]
									},
									"id": 295,
									"nodeType": "IfStatement",
									"src": "2543:262:0",
									"trueBody": {
										"id": 287,
										"nodeType": "Block",
										"src": "2582:163:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 269,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 265,
																	"name": "nameToSaleOffer",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 26,
																	"src": "2604:15:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																		"typeString": "mapping(bytes32 => uint256)"
																	}
																},
																"id": 267,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 266,
																	"name": "name",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 238,
																	"src": "2620:4:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "2604:21:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "30",
																"id": 268,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2628:1:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															},
															"src": "2604:25:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 264,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															1468,
															1469
														],
														"referencedDeclaration": 1468,
														"src": "2596:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
															"typeString": "function (bool) pure"
														}
													},
													"id": 270,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2596:34:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 271,
												"nodeType": "ExpressionStatement",
												"src": "2596:34:0"
											},
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 276,
																"name": "nameToSaleOffer",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 26,
																"src": "2673:15:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																	"typeString": "mapping(bytes32 => uint256)"
																}
															},
															"id": 278,
															"indexExpression": {
																"argumentTypes": null,
																"id": 277,
																"name": "name",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 238,
																"src": "2689:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "2673:21:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"expression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 272,
																"name": "nameToAddress",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 22,
																"src": "2644:13:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
																	"typeString": "mapping(bytes32 => address)"
																}
															},
															"id": 274,
															"indexExpression": {
																"argumentTypes": null,
																"id": 273,
																"name": "name",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 238,
																"src": "2658:4:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes32",
																	"typeString": "bytes32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "2644:19:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"id": 275,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "transfer",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2644:28:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 279,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2644:51:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 280,
												"nodeType": "ExpressionStatement",
												"src": "2644:51:0"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 285,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 281,
															"name": "nameToSaleOffer",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 26,
															"src": "2709:15:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
																"typeString": "mapping(bytes32 => uint256)"
															}
														},
														"id": 283,
														"indexExpression": {
															"argumentTypes": null,
															"id": 282,
															"name": "name",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 238,
															"src": "2725:4:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "2709:21:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 284,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2733:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "2709:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 286,
												"nodeType": "ExpressionStatement",
												"src": "2709:25:0"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 301,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 296,
												"name": "nameToAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 22,
												"src": "2814:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
													"typeString": "mapping(bytes32 => address)"
												}
											},
											"id": 298,
											"indexExpression": {
												"argumentTypes": null,
												"id": 297,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 238,
												"src": "2828:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "2814:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 299,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1465,
												"src": "2836:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2836:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2814:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 302,
									"nodeType": "ExpressionStatement",
									"src": "2814:32:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 306,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 303,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1465,
												"src": "2860:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 304,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "value",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2860:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"id": 305,
											"name": "price",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 244,
											"src": "2872:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "2860:17:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 319,
									"nodeType": "IfStatement",
									"src": "2856:86:0",
									"trueBody": {
										"id": 318,
										"nodeType": "Block",
										"src": "2879:63:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 315,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 312,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1465,
																	"src": "2913:3:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 313,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "value",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "2913:9:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "-",
															"rightExpression": {
																"argumentTypes": null,
																"id": 314,
																"name": "price",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 244,
																"src": "2925:5:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"src": "2913:17:0",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"expression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 307,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1465,
																"src": "2893:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 310,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "2893:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"id": 311,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "transfer",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2893:19:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 316,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2893:38:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 317,
												"nodeType": "ExpressionStatement",
												"src": "2893:38:0"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 321,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "buy",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 235,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 234,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 321,
									"src": "2363:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 233,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "2363:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2362:15:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 236,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2415:0:0"
						},
						"scope": 351,
						"src": "2350:598:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 349,
							"nodeType": "Block",
							"src": "3023:138:0",
							"statements": [
								{
									"assignments": [
										329
									],
									"declarations": [
										{
											"constant": false,
											"id": 329,
											"name": "name",
											"nodeType": "VariableDeclaration",
											"scope": 350,
											"src": "3033:12:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											},
											"typeName": {
												"id": 328,
												"name": "bytes32",
												"nodeType": "ElementaryTypeName",
												"src": "3033:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 333,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 331,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 323,
												"src": "3056:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											],
											"id": 330,
											"name": "toLower",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 105,
											"src": "3048:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_bytes32_$returns$_t_bytes32_$",
												"typeString": "function (bytes32) pure returns (bytes32)"
											}
										},
										"id": 332,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3048:14:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "3033:29:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 340,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 335,
														"name": "nameToAddress",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 22,
														"src": "3080:13:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_bytes32_$_t_address_$",
															"typeString": "mapping(bytes32 => address)"
														}
													},
													"id": 337,
													"indexExpression": {
														"argumentTypes": null,
														"id": 336,
														"name": "name",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 329,
														"src": "3094:4:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes32",
															"typeString": "bytes32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "3080:19:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 338,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1465,
														"src": "3103:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 339,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "3103:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3080:33:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 334,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1468,
												1469
											],
											"referencedDeclaration": 1468,
											"src": "3072:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 341,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3072:42:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 342,
									"nodeType": "ExpressionStatement",
									"src": "3072:42:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 347,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 343,
												"name": "nameToSaleOffer",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 26,
												"src": "3124:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_bytes32_$_t_uint256_$",
													"typeString": "mapping(bytes32 => uint256)"
												}
											},
											"id": 345,
											"indexExpression": {
												"argumentTypes": null,
												"id": 344,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 329,
												"src": "3140:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes32",
													"typeString": "bytes32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "3124:21:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 346,
											"name": "_price",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 325,
											"src": "3148:6:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "3124:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 348,
									"nodeType": "ExpressionStatement",
									"src": "3124:30:0"
								}
							]
						},
						"documentation": null,
						"id": 350,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "putForSale",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 326,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 323,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 350,
									"src": "2974:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 322,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "2974:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 325,
									"name": "_price",
									"nodeType": "VariableDeclaration",
									"scope": 350,
									"src": "2989:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 324,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2989:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2973:28:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 327,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "3023:0:0"
						},
						"scope": 351,
						"src": "2954:207:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					}
				],
				"scope": 352,
				"src": "93:3070:0"
			}
		],
		"src": "0:3164:0"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {
		"1": {
			"events": {},
			"links": {},
			"address": "0x0f0d6407139d32c35a49ea06baa228ab45d2ccba",
			"transactionHash": "0x4e00469951d05023b3565a2751333fe2acc4373fb9087f30a91f38c8cbd5c2b6"
		},
		"3": {
			"events": {},
			"links": {},
			"address": "0xe58c9f36ce31bf9745c26db39564d80a5de30dda",
			"transactionHash": "0x5e2fa24946a904e9f5c4e98bbc35f4e5a3b84a6101bbd1a9d885d49540158fba"
		},
		"5777": {
			"events": {},
			"links": {},
			"address": "0x9f98c46862f9e817ebe65916ab4bd5c129df5959",
			"transactionHash": "0x90bd882d3faf9547895ed5bf3a3836479f90feccd187936ee5993952ff33db4a"
		}
	},
	"schemaVersion": "2.0.1",
	"updatedAt": "2018-11-21T07:25:59.786Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Alias.json
// module id = 539
// module chunks = 0